import { Link, useRouteError } from 'react-router-dom';

export function NotFoundPage() {
  const error = useRouteError();
  return (
    <div className="card text-center space-y-4">
      <h1 className="text-2xl font-bold">페이지를 찾을 수 없습니다</h1>
      <p className="text-ink-muted">{(error as Error)?.message ?? '주소를 다시 확인해주세요.'}</p>
      <Link to="/" className="btn-primary">처음으로</Link>
    </div>
  );
}
